import { useCallback, useMemo, useState } from 'react';
const useHoverAndFocusState = ({ onBlurHandler, onFocusHandler, onMouseEnterHandler, onMouseLeaveHandler, }) => {
    const [focused, setFocused] = useState();
    const [hovered, setHovered] = useState();
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-restricted-syntax
    const onBlur = useCallback((event) => {
        onBlurHandler?.(event);
        setFocused(false);
    }, [onBlurHandler]);
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-restricted-syntax
    const onFocus = useCallback((event) => {
        onFocusHandler?.(event);
        setFocused(true);
    }, [onFocusHandler]);
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-restricted-syntax
    const onMouseEnter = useCallback((event) => {
        onMouseEnterHandler?.(event);
        setHovered(true);
    }, [onMouseEnterHandler]);
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-restricted-syntax
    const onMouseLeave = useCallback((event) => {
        onMouseLeaveHandler?.(event);
        setHovered(false);
    }, [onMouseLeaveHandler]);
    return useMemo(() => [
        {
            focused,
            hovered,
        },
        {
            onBlur,
            onFocus,
            onMouseEnter,
            onMouseLeave,
        },
    ], [focused, hovered, onBlur, onFocus, onMouseEnter, onMouseLeave]);
};
export default useHoverAndFocusState;
